import { render, staticRenderFns } from "./AttachmentCategoriesConfigs.vue?vue&type=template&id=006422ca&"
import script from "./AttachmentCategoriesConfigs.vue?vue&type=script&lang=js&"
export * from "./AttachmentCategoriesConfigs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports